/* eslint-disable max-lines-per-function */
import type { JSX } from 'react';
import { useState } from 'react';
import { Label } from '@/components/ui/label';
import { TagInput } from '@/components/ui/tag-input';
import { useJobPositionSuggestions } from '../../hooks/useJobPositionSuggestions';
import type { FormSectionProps } from './types';

export function SkillsSection({ errors, setValue, watch }: FormSectionProps): JSX.Element {
  const skills = watch('skills') || [];
  const requiredSkills = watch('requiredSkills') || [];
  const preferredSkills = watch('preferredSkills') || [];
  const technologies = watch('technologies') || [];

  const [skillsQuery, setSkillsQuery] = useState('');
  const [requiredSkillsQuery, setRequiredSkillsQuery] = useState('');
  const [preferredSkillsQuery, setPreferredSkillsQuery] = useState('');
  const [technologiesQuery, setTechnologiesQuery] = useState('');

  const { data: skillsSuggestions } = useJobPositionSuggestions('skills', skillsQuery);
  const { data: requiredSkillsSuggestions } = useJobPositionSuggestions(
    'requiredSkills',
    requiredSkillsQuery
  );
  const { data: preferredSkillsSuggestions } = useJobPositionSuggestions(
    'preferredSkills',
    preferredSkillsQuery
  );
  const { data: technologiesSuggestions } = useJobPositionSuggestions(
    'technologies',
    technologiesQuery
  );

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Skills & Technologies</h3>
      <div className="space-y-2">
        <Label>Skills</Label>
        <TagInput
          value={skills}
          onChange={(value) => setValue('skills', value)}
          placeholder="Add skills..."
          suggestions={skillsSuggestions}
          onQueryChange={setSkillsQuery}
        />
        {errors.skills && <p className="text-sm text-red-500">{errors.skills.message}</p>}
      </div>
      <div className="space-y-2">
        <Label>Required Skills</Label>
        <TagInput
          value={requiredSkills}
          onChange={(value) => setValue('requiredSkills', value)}
          placeholder="Add required skills..."
          suggestions={requiredSkillsSuggestions}
          onQueryChange={setRequiredSkillsQuery}
        />
        {errors.requiredSkills && (
          <p className="text-sm text-red-500">{errors.requiredSkills.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label>Preferred Skills</Label>
        <TagInput
          value={preferredSkills}
          onChange={(value) => setValue('preferredSkills', value)}
          placeholder="Add preferred skills..."
          suggestions={preferredSkillsSuggestions}
          onQueryChange={setPreferredSkillsQuery}
        />
        {errors.preferredSkills && (
          <p className="text-sm text-red-500">{errors.preferredSkills.message}</p>
        )}
      </div>
      <div className="space-y-2">
        <Label>Technologies</Label>
        <TagInput
          value={technologies}
          onChange={(value) => setValue('technologies', value)}
          placeholder="Add technologies..."
          suggestions={technologiesSuggestions}
          onQueryChange={setTechnologiesQuery}
        />
        {errors.technologies && (
          <p className="text-sm text-red-500">{errors.technologies.message}</p>
        )}
      </div>
    </div>
  );
}
